module.exports = __webpack_public_path__ + "img/icon3-2.6dac5b76.png";